import { useState, useEffect } from "react";
import css from "../../assets/css/gamehis.module.css";
import socket from "../Components/socket";
import Refer from "./Refer";
import Gamehistory from "./Gamehistory";
import Referralhis from "./Referralhis";
import "../../assets/css/landing.css";
import Transactionhistory from "./Transactionhistory";
import { apiRequest } from "../../apiService/allApi";

const History = () => {
  const [user, setUser] = useState();

  const meData = async () => {
    socket.emit("getprofile");

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const res = await apiRequest(`me`, "GET", null, headers);

    setUser(res.data);
  };

  useEffect(() => {
    meData();
  }, []);

  return (
    <>
      <div className="leftContainer page_layout">
        <div className="Orher_page_main_section">
          <section className="transaction_main_section_modal">
            <div className="">
              <h2 className="text-center mt-1 mb-3 animated-text"> History</h2>

              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active tabs"
                    id="game-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#game"
                    type="button"
                    role="tab"
                    aria-controls="game"
                    aria-selected="true"
                  >
                    Game
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link mx-3"
                    id="transaction-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#transaction"
                    type="button"
                    role="tab"
                    aria-controls="transaction"
                    aria-selected="false"
                  >
                    Transaction
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    style={{ marginRight: "0" }}
                    className="nav-link mr-0"
                    id="others-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#others"
                    type="button"
                    role="tab"
                    aria-controls="others"
                    aria-selected="false"
                    onClick={Refer}
                  >
                    Referral
                  </button>
                </li>
              </ul>

              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="game"
                  role="tabpanel"
                  aria-labelledby="game-tab"
                >
                  <Gamehistory />
                </div>

                <div
                  className="tab-pane fade"
                  id="transaction"
                  role="tabpanel"
                  aria-labelledby="transaction-tab"
                >
                  <Transactionhistory />
                </div>

                <div
                  className="tab-pane fade"
                  id="others"
                  role="tabpanel"
                  aria-labelledby="others-tab"
                >
                  <Referralhis />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default History;
